import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import EditScaleUnitApi from "../../../api/scale-unit/EditScaleUnitApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { getCurrencyCodes } from "../../../helpers/currencyCodes";

const { Option } = Select;

function EditScaleUnitModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    setValuesChanged(false);
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await EditScaleUnitApi(
      props.unit?.id,
      values.unitName,
      values.symbol,
      values.abbreviation
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Scale unit edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit scale unit. Try again later."
      );
    }
    handleCancel();
  }
  return (
    <Modal
      title="Edit scale unit"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="scaleUnit"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          unitName: props.unit?.unitName,
          symbol: props.unit?.symbol,
          abbreviation: props.unit?.abbreviation,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item
          label="Unit name"
          name="unitName"
          rules={[{ required: true, message: "Please enter a unit name!" }]}
        >
          <Input placeholder="Unit name" />
        </Form.Item>
        <Form.Item
          label="Symbol"
          name="symbol"
          rules={[{ required: true, message: "Please enter symbol!" }]}
        >
          <Input placeholder="Symbol" />
        </Form.Item>
        <Form.Item
          label="Abbreviation"
          name="abbreviation"
          rules={[{ required: true, message: "Please enter abbreviation!" }]}
        >
          <Select
            showSearch
            placeholder="Select a currency"
            optionFilterProp="children"
          >
            {getCurrencyCodes.map((code) => (
              <Option key={code} value={code}>
                {code}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditScaleUnitModal;
